import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { green } from "@mui/material/colors";


const StyledSnackbar = styled(Snackbar)(({ theme, variant, className }) => ({
  "&": {
    bottom: "0",
    top: "80px",
    right: "40px",
    justifyContent: "flex-end",
    alignItems: "flex-start",
  },
  "& .MuiButtonBase-root": {
    color: "#4A4A4A",
  },
  "& .MuiPaper-root": {
    backgroundColor: "#fff",
  },
  "&.warning": {
    "& .MuiPaper-root": {
      border: "1px solid #F4A81D",
    },
  },
  "&.error": {
    "& .MuiPaper-root": {
      border: "1px solid #E10624",
    },
  },
  "&.success": {
    "& .MuiPaper-root": {
      border: "1px solid #2D62ED",
    },
  },
  "& .MuiSnackbarContent-message": {
    padding: "0 0",
  },
}));

{
  /*HeroIcons specified for all variant */
}
const variantIcon = {
  success: "check",
  warning: "warning",
  error: "heroicons-outline:x",
};

function CustomToaster({ title, subTitle, variant }) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setOpen(true);
  }, []);
  return (
    <div className="mt-[101px]">
      <StyledSnackbar
        sx={{ p: "0px" }}
        open={open}
        style={{ zIndex: 1111 }}
        className={`${
          variant == "success"
            ? "success"
            : variant == "warning"
            ? "warning"
            : "error"
        }`}
        onClose={handleClose}
        ContentProps={{
          variant: "warning",
          headlineMapping: {
            body1: "div",
            body2: "div",
          },
        }}
      >
        <SnackbarContent
          sx={{
            borderRadius: "10px",
            m: "0",
            maxWidth: "345px",
          }}
          className="h-auto p-0"
          message={
            <div className="h-auto flex flex-row justify-between border-gray-700 rounded-l-[9px] ">
              <Typography
                sx={{
                  backgroundColor: "#FFFFFF",
                  color: "black",
                }}
                className="text-[14px] leading-[22px] w-full m-[10px] flex-wrap shrink text-left"
              >
                <p
                  className={`${
                    variant == "success"
                      ? "text-[#2D62ED] "
                      : variant == "warning"
                      ? "text-[#F4A81D]"
                      : "text-[#E10624]"
                  } text-[14px] font-[600] pt-[10px] pb-[8px] capitalize w-0 "`}
                >
                  {title}
                </p>
                <p className="text-[#4A4A4A] text-[14px] font-[300] pb-[20px] ">
                  {subTitle}
                </p>
              </Typography>
              <div className="absolute right-0">
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={handleClose}
                  size="large"
                  width="50px"
                >
                </IconButton>
              </div>
            </div>
          }
        />
      </StyledSnackbar>
    </div>
  );
}

export default CustomToaster;
